// extracted by mini-css-extract-plugin
module.exports = {"corner":"D_bv","container":"D_c"};